import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/$orgId/providers/")({
  beforeLoad: () => {
    throw redirect({ to: "/org/providers" });
  },
});
